let rates = {
  INR: 1,
  USD: 0,
  EUR: 0,
  AED: 0,
  SAR: 0,
  QAR: 0,
  GBP: 0,
  CAD: 0,
};

// Fetch rates
fetch("https://open.er-api.com/v6/latest/INR")
  .then((res) => res.json())
  .then((data) => {
    // Filter to of only need
    rates.USD = data.rates.USD;
    rates.EUR = data.rates.EUR;
    rates.AED = data.rates.AED;
    rates.SAR = data.rates.SAR;
    rates.QAR = data.rates.QAR;
    rates.GBP = data.rates.GBP;
    rates.CAD = data.rates.CAD;
  })
  .catch((err) => console.error(err));

// Convert function
export const convertCurrency = (priceInINR, currency) => {
  return priceInINR * (rates[currency] || 1);
};
